import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorBoxModel } from '../../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../../models/qfilter.model';
import { NumberKMPipe } from '../../../../../pipes/numberKMPipe';
import { AnalyticsService } from '../../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';

@Component({
  selector: 'app-promo-analysis-results',
  templateUrl: './promo-results.component.html',
  styleUrls: ['./promo-results.component.css']
})
// Pagina 52
export class PromoResultsComponent implements OnInit {

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public promoError = false;
  public selectOneError: string;
  public data: QFilterModel;
  trendFatturatoChart: LoyaltyChart;
  scontrinoMedioChart: LoyaltyChart;
  show_results = false;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {

  }

  ngOnInit() {

    this.translate.get([
      'loyalty_chart.period',
      'loyalty_chart.value'
    ]).subscribe((t) => {
      this.translations = {
        period: t['loyalty_chart.period'],
        value: t['loyalty_chart.value']
      };
      this.initCharts();
    });

    this.translate.get('promo.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });

  }

  initCharts() {
    this.trendFatturatoChart = new LoyaltyChart('line', '€');
    this.trendFatturatoChart.options.xAxis.title.text = this.translations.period;
    this.trendFatturatoChart.options.yAxis.title.text = this.translations.value;
    this.trendFatturatoChart.options.chart.zoomType = 'xy';
    this.trendFatturatoChart.options.tooltip = {
      formatter: function() {
        return '<b>' + NumberKMPipe.formatDynamic(this.y, '€') + '</b>';
      }
    };

    this.scontrinoMedioChart = new LoyaltyChart('line', '€');
    this.scontrinoMedioChart.options.xAxis.title.text = this.translations.period;
    this.scontrinoMedioChart.options.yAxis.title.text = this.translations.value;
    this.scontrinoMedioChart.options.chart.zoomType = 'xy';
    this.scontrinoMedioChart.options.tooltip = {
      formatter: function() {
        return '<b>' + NumberKMPipe.formatDynamic(this.y, '€') + '</b>';
      }
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }


  searchValue(data: QFilterModel) {

    this.data = data;

    if (data['promo'] != null) {
      this.indicators = [];
      this.indicatorService.indicatorCalculation('promos.Q224', this.data).subscribe(Q224 => {

        /*Q224*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'investimento_totale')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q225*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'fatturato_promo')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q226*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'sconto_medio')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q227*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'spesa_associata')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q228*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'spesa_incrementale')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));
        /*Q229*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'roi')], {dynamic: true, decimal_value: 1, hide_prev_value: true}));
        /*Q230*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'dimensione_target')], {dynamic: true, hide_prev_value: true}));
        /*Q231*/
        this.indicators.push(new IndicatorBoxModel([Q224.find(r => r.name === 'redemption')], {dynamic: true, decimal_value: 2, hide_prev_value: true}));

      });

      this.show_results = true

    } else {
      this.data = null;
      this.promoError = true;
    }

    this.chartsService.loadChart(this.trendFatturatoChart, 'promos.Q240', data, this.indicatorService, this.translate, false, LoyaltyChart.colors, 'promo');
    this.chartsService.loadChart(this.scontrinoMedioChart, 'promos.Q241', data, this.indicatorService, this.translate, false, LoyaltyChart.colors, 'promo');
  }

  public toogleErrorPromoDialog() {
    this.promoError = !this.promoError;
  }

  public get filterApplied(): boolean
  {
    return this.data != null;
  }

  resetData() {
    this.show_results = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/analysis/results/promo-results.component.ts